import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/index/index'

import OrderStates from '@/components/index/OrderStates' //訂單状态
import Orderlist from '@/components/index/Orderlist' //訂單状态
import orderlislist from '@/components/index/orderlislist' //訂單状态

import Receipt from '@/components/index/Receipt' //訂單状态
import Receivables from '@/components/index/Receivables'//收款
import MyUser from "@/components/index/MyUser" //個人 

import addMerchant from '@/components/Receivables/adddetail'//增加商户

import Googlecode from '@/components/banggoogle/Googlecode'//绑定谷歌


import PhoneLogin from '@/components/login/phone/phoneLogin'//临时登錄
import Login from '@/components/login/phone/Login'//手机登錄

import Recharge from '@/components/my/Recharge'//充值

import CashWithdrawal from '@/components/my/CashWithdrawal'//提現

import security from '@/components/my/security'//帳戶安全

import inviteInfo from '@/components/my/inviteInfo' //邀请資訊

import changeCode from '@/components/my/changeCode'//更改密码或者谷歌验证码

import Capital from '@/components/my/Capital'// 資金流水

import supplement from '@/components/my/supplement'//流水補充

import supmetdetail from '@/components/my/supmetdetail'//流水補充详情

import Frenchhistory from '@/components/my/Frenchhistory'//流水補充详情

import Frenchhistorydetail from '@/components/my/Frenchhistorydetail'//流水補充详情


import cropImage from '@/components/my/cropImage'//

import orderdetail from '@/components/order/orderdetail'// 訂單详情

import DeliveryOrderDetail from '@/components/order/DeliveryOrderDetail'// 交割详情

import subSellOrderFile from '@/components/order/sub_sell_order_file'// 補充訂單流水

import Cashaudit from '@/components/my/Cashaudit'// 訂單详情

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index',  // /systemError 维护   /index 正常
    },
    {
      path: '/index',
      component: Index,
      children: [
        {
          path: '',
          redirect: '/Orderlist'
        }
        , {
          path: '/Orderlist',
          name: 'Orderlist',
          component: Orderlist,
          meta: { title: '訂單列表' }
        },
        {
          path: '/orderlislist',
          name: 'orderlislist',
          component: orderlislist,
          meta: { title: '訂單歷史' }
        }

        , {
          path: '/OrderStates',
          name: 'OrderStates',
          component: OrderStates,
          meta: { title: '訂單状态' }
        }, {
          path: '/Receipt',
          name: 'Receipt',
          component: Receipt,
          meta: { title: '收款' }
        }
        , {
          path: '/Receivables',
          name: 'Receivables',
          component: Receivables,
          meta: { title: '收款帳戶' }
        }
        , {
          path: '/MyUser',
          name: 'MyUser',
          component: MyUser,
          meta: { title: '個人' }
        }


      ]
    },
    {
      path: '/phonelogin',
      name: 'phonelogin',
      component: PhoneLogin,
      meta: { title: '手机登錄' }
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: { title: '手机登錄' }
    },
    {
      path: '/addMerchant',
      name: 'addMerchant',
      component: addMerchant,
      meta: { title: '增加帳戶' }
    },
    {
      path: '/Googlecode',
      name: 'Googlecode',
      component: Googlecode,
      meta: { title: '绑定谷歌' }
    },
    {
      path: '/Recharge',
      name: 'Recharge',
      component: Recharge,
      meta: { title: '充值' }
    },
    {
      path: '/CashWithdrawal',
      name: 'CashWithdrawal',
      component: CashWithdrawal,
      meta: { title: '提現' }
    },
    {
      path: '/Cashaudit',
      name: 'Cashaudit',
      component: Cashaudit,
      meta: { title: '提現' }

    }
    , {
      path: '/security',
      name: 'security',
      component: security,
      meta: { title: '帳戶安全' }
    }, 
    , {
      path: '/inviteInfo',
      name: 'inviteInfo',
      component: inviteInfo,
      meta: { title: '邀请資訊' }
    },{
      path: '/changeCode',
      name: 'changeCode',
      component: changeCode,
      meta: { title: '帳戶安全' }
    }, {
      path: '/Capital',
      name: 'Capital',
      component: Capital,
      meta: { title: '資金流水' }
    }, {
      path: '/supplement',
      name: 'supplement',
      component: supplement,
      meta: { title: '流水明細補充' }
    }, {
      path: '/supmetdetail',
      name: 'supmetdetail',
      component: supmetdetail,
      meta: { title: '補充' }
    }
    , {
      path: '/Frenchhistory',
      name: 'Frenchhistory',
      component: Frenchhistory,
      meta: { title: '法币補充歷史' }
    }
    , {
      path: '/Frenchhistorydetail',
      name: 'Frenchhistorydetail',
      component: Frenchhistorydetail,
      meta: { title: '法币補充' }
    }
    , {
      path: '/cropImage',
      name: 'cropImage',
      component: cropImage,
      meta: { title: '头像剪切' }
    }
    , {
      path: '/orderdetail',
      name: 'orderdetail',
      component: orderdetail,
      meta: { title: '訂單详情' }
    }
    , {
      path: '/DeliveryOrderDetail',
      name: 'DeliveryOrderDetail',
      component: DeliveryOrderDetail,
      meta: { title: '交割详情' }
    }
    , {
      path: '/sub_sell_order_file',
      name: 'sub_sell_order_file',
      component: subSellOrderFile,
      meta: { title: '補充卖单截图' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js